export const subtitles = {
'DHM29': 'seconds'
}
